
import './styles.css';
import InsaneTable from '../../component/insane-table'

//////////// REDUX | STORE | SERVICE /////////////
import { HttpRequest } from '../../service/HttpRequest';

function ProductionChecksheetGroup() {

    let checksheetList = [];

    HttpRequest("/admin/pd/checksheet/get", {}).then(data => {
        // console.log("_plant" ,data);
        if (data.result === "OK") {
            for (let i = 0; i < data.checksheets.length; i++) {
                const _checksheet = data.checksheets[i];
                checksheetList.push({
                    displayName: _checksheet.checksheetid + " -- " +_checksheet.checksheetname + "",
                    value: _checksheet.checksheetid
                })
            }
        }
    });

    const tableOption = {
        tableName: "Group",
        className: "",
        search: [
            {
                reqName: "checksheetid",
                displayName: "Check Sheet ID",
                element: "select",
                placeholder: "Enter Check Sheet ID.",
                option: checksheetList
            },
            {
                reqName: "search_equipmentgroupname",
                displayName: "Group Name",
                element: "input",
                placeholder: "Enter Group Name."
            },
            {
                reqName: "search_equipmentgroupcode",
                displayName: "Group Code",
                element: "input",
                placeholder: "Enter Group Code."
            }
        ],
        mapTable: [
            {
                displayName: "Group ID",
                attName: "equipmentgroupid",
                type: "text",
                form: {
                    validate: true,
                    enable: false,
                    element: "input"
                }
            },
            {
                displayName: "Group Name",
                attName: "equipmentgroupname",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Group Code",
                attName: "equipmentgroupcode",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Checksheet ID",
                attName: "checksheetid",
                type: "id",
                form: {
                    validate: true,
                    enable: true,
                    element: "select",
                    option: checksheetList
                }
            },
            {
                displayName: "Sort Index",
                attName: "sortindex",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Loop",
                attName: "loop",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Created By",
                attName: "createdbyuserid",
                type: "text",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            },
            {
                displayName: "Created Time",
                attName: "createdtime",
                type: "date",
                form: {
                    validate: true,
                    enable: true,
                    element: "input"
                }
            }
        ],
        api: {
            view: {
                enable: true,
                url: "/admin/pd/equipmentgroup/get",
                dataReq: {
                    "index": 0,
                    "count": 10,
                    "search_equipmentgroupname":"",
                    "search_equipmentgroupcode":""
                }
            },
            insert: {
                enable: true,
                url: "/admin/pd/equipmentgroup/update",
                dataReq: {
                    "equipmentgroupcode": "",
                    "checksheetid": "",
                    "equipmentgroupname": "",
                    "sortindex": "",
                    "loop": ""
                }
            },
            update: {
                enable: true,
                url: "/admin/pd/equipmentgroup/update",
                dataReq: {
                    "equipmentgroupid": "",
                    "equipmentgroupcode": "",
                    "checksheetid": "",
                    "equipmentgroupname": "",
                    "sortindex": "",
                    "loop": ""
                }
            },
            delete: {
                enable: true,
                url: "/admin/pd/equipmentgroup/delete",
                dataReq: {
                    "equipmentgroupid": ""
                }
            }
        },
        action: [
            {
                name: "Edit",
                mode: "modal-form", /// page, modal, form
                option: {
                    type: "update"
                }
            }
        ],
        qr: {
            type: "",
            sampleValue: {
                "type" : "group",
                "group" : "",
                "equipment" : ""
            },
            option: {
                bgColor: '#FFFFFF',
                fgColor: '#000000',
                level: 'L',
                size: 64,
                title: ""
            },
            mapValue: [
                {
                    attName: "group",
                    attMap: "equipmentgroupid",
                    type: "text",
                }
            ]
        }
    }

    return (
        <div className='content'>

            <div className='content-page'>
                <div className='head-content-page'>Equipment Group Management.</div>
                <InsaneTable option={tableOption}></InsaneTable>
            </div>

        </div >
    );
}

export default ProductionChecksheetGroup;